import i18n from 'translations/config';
import InternalRequestModel from 'api/models/InternalRequestModel';
import InternalRequestNotificationsEventCatcher from '../../../../realTimeApi/eventCatchers/internalRequest/InternalRequestNotificationsEventCatcher';

class InternalRequestNotificationDescriptionUtils {
  static IR_MESSAGE_GETTERS_BY_UPDATE_TYPE = Object.freeze({
    [InternalRequestNotificationsEventCatcher.IR_UPDATE_TYPES.IR_CREATED]: (
      _requesterName,
      internalRequestType
    ) => this.getCreatedMessage(internalRequestType),
    [InternalRequestNotificationsEventCatcher.IR_UPDATE_TYPES.IR_SUBMITTED]: (
      _requesterName,
      internalRequestType
    ) => this.getSubmittedMessage(internalRequestType),
    [InternalRequestNotificationsEventCatcher.IR_UPDATE_TYPES.IR_APPROVED]: (
      internalRequestId,
      internalRequestType
    ) => this.getApprovedMessage(internalRequestId, internalRequestType),
    [InternalRequestNotificationsEventCatcher.IR_UPDATE_TYPES.IR_REJECTED]: (
      internalRequestId,
      rejectionReason,
      internalRequestType
    ) =>
      this.getRejectedMessage(
        internalRequestId,
        rejectionReason,
        internalRequestType
      ),
    [InternalRequestNotificationsEventCatcher.IR_UPDATE_TYPES
      .IR_PENDING_CLOSED]: (internalRequestId, internalRequestType) =>
      this.getPendingClosedMessage(internalRequestId, internalRequestType),
    [InternalRequestNotificationsEventCatcher.IR_UPDATE_TYPES.IR_CLOSED]: (
      internalRequestId,
      internalRequestType
    ) => this.getClosedMessage(internalRequestId, internalRequestType),
  });

  static getTypeLabel(internalRequestType) {
    const i18nKey = InternalRequestModel.READABLE_TYPE[internalRequestType];
    return i18nKey ? i18n.t(i18nKey) : 'Internal Request';
  }

  static getCreatedMessage(internalRequestType) {
    return `${this.getTypeLabel(internalRequestType)} ${i18n.t(
      'internalRequest.activity.notifications.created'
    )}`;
  }

  static getSubmittedMessage(internalRequestType) {
    return `${this.getTypeLabel(internalRequestType)} ${i18n.t(
      'internalRequest.activity.notifications.submitted'
    )}`;
  }

  static getApprovedMessage(internalRequestId, internalRequestType) {
    return `${this.getTypeLabel(
      internalRequestType
    )} #${internalRequestId} ${i18n.t(
      'internalRequest.activity.notifications.approved'
    )}`;
  }

  static getRejectedMessage(
    internalRequestId,
    rejectionReason,
    internalRequestType
  ) {
    const rejectedLabel = i18n.t(
      'internalRequest.activity.notifications.rejected'
    );
    if (rejectionReason) {
      return `${this.getTypeLabel(
        internalRequestType
      )} #${internalRequestId} ${rejectedLabel}: ${rejectionReason}`;
    }
    return `${this.getTypeLabel(
      internalRequestType
    )} #${internalRequestId} ${rejectedLabel}`;
  }

  static getPendingClosedMessage(internalRequestId, internalRequestType) {
    return `${this.getTypeLabel(
      internalRequestType
    )} #${internalRequestId} ${i18n.t(
      'internalRequest.activity.notifications.pendingClosed'
    )}`;
  }

  static getClosedMessage(internalRequestId, internalRequestType) {
    return `${this.getTypeLabel(
      internalRequestType
    )} #${internalRequestId} ${i18n.t(
      'internalRequest.activity.notifications.closed'
    )}`;
  }
}

export default InternalRequestNotificationDescriptionUtils;
